import { render, staticRenderFns } from "./hospital-manage.vue?vue&type=template&id=434b982c&"
import script from "./hospital-manage.vue?vue&type=script&lang=js&"
export * from "./hospital-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports